import { Link, useParams } from "react-router-dom";
import { eventOpenToStudent } from "../domain/data";
import { waitlistPlace } from "../domain/registrations";
import { useEvents } from "../state/events";
import { useLocale } from "../state/i18n";
import { useStudents } from "../state/students";
import { ChildSwitcher, PrototypeBanner, StudentNav } from "../components/ui";

export function StudentHome() {
  const { studentId = "mike" } = useParams();
  const { getStudent } = useStudents();
  const student = getStudent(studentId);
  const { upcomingEvents, countsFor, registrationForStudent, registrationsFor } =
    useEvents();
  const { t } = useLocale();

  if (!student) {
    return (
      <div className="app">
        <PrototypeBanner />
        <main className="shell">
          <p>{t("student.unknown")}</p>
          <Link to="/">{t("student.back")}</Link>
        </main>
      </div>
    );
  }

  const openEvents = upcomingEvents.filter((e) =>
    eventOpenToStudent(e, student),
  );

  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <StudentNav studentId={student.id} />
        <ChildSwitcher studentId={student.id} />
        <p className="meta">{t("student.landing")}</p>
        <h1>{t("student.hi", { name: student.given })}</h1>
        <p className="lede">
          {t("student.metaLine", {
            school: student.school,
            grade: student.grade,
          })}
        </p>

        <div className="wire dashed">
          <div className="meta">{t("student.yourProfile")}</div>
          <div className="row">
            <div>
              <strong>
                {student.given} {student.family}
              </strong>
            </div>
            <Link className="tag" to={`/student/${student.id}/profile`}>
              {t("nav.profile")}
            </Link>
          </div>
        </div>

        <h2>{t("student.upcoming")}</h2>
        <p className="lede">{t("student.upcomingLede")}</p>
        {openEvents.length === 0 ? (
          <div className="wire dashed">
            <div className="meta">{t("student.noUpcoming")}</div>
          </div>
        ) : (
          <ul className="list-plain">
            {openEvents.map((event) => {
              const counts = countsFor(event.id);
              const registration = registrationForStudent(event.id, student.id);
              const place =
                registration?.status === "waitlisted"
                  ? waitlistPlace(registrationsFor(event.id), student.id)
                  : null;
              const label =
                registration?.status === "registered"
                  ? t("student.registered")
                  : registration?.status === "waitlisted"
                    ? place === 1
                      ? t("studentEvents.waitlistNext")
                      : t("studentEvents.waitlistPlace", { place: place ?? "—" })
                    : counts.remaining > 0
                      ? t("events.spots", { count: counts.remaining })
                      : event.waitlistEnabled
                        ? t("events.waitlistOpen")
                        : t("events.full");
              return (
                <li key={event.id}>
                  <Link to={`/student/${student.id}/events/${event.id}`}>
                    <div className="row">
                      <div>
                        <div className="title">
                          <strong>{event.name}</strong>
                        </div>
                        <div className="anno">
                          {event.dateLabel} · {event.timeLabel} · {event.location}
                        </div>
                      </div>
                      <div className="tag muted">{label}</div>
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </main>
    </div>
  );
}
